<template>
  <v-row class="ranking-section">
    <Can I="readAll" a="SalesNote">
      <v-col cols="12" md="6">
        <v-card class="bespoke-ranking-card h-100" flat>
          <div class="metric-accent blue-accent"></div>
          <v-card-title class="pa-6 pb-2">
            <div class="d-flex flex-column">
              <span class="ranking-subtitle">Rendimiento Comercial</span>
              <span class="ranking-title text-left">Top 5 Clientes</span>
            </div>
            <v-spacer></v-spacer>
            <v-chip x-small color="blue lighten-5" class="blue--text font-weight-black">PERÍODO</v-chip>
          </v-card-title>
          
          <v-card-text class="pa-0">
            <!-- Loading State -->
            <div v-if="loading" class="pa-6">
              <v-skeleton-loader v-for="i in 5" :key="i" type="list-item-two-line" class="mb-2"></v-skeleton-loader>
            </div>
            
            <!-- Real Data -->
            <div v-else class="bespoke-list">
              <template v-if="topCustomersList.length > 0">
                <div 
                  v-for="(customer, index) in topCustomersList" 
                  :key="index"
                  class="bespoke-list-item d-flex align-center pa-4"
                >
                  <div class="ranking-position mr-4">0{{ index + 1 }}</div>
                  <div class="ranking-info flex-grow-1">
                    <div class="ranking-name text-truncate text-left">{{ customer.name }}</div>
                    <div class="ranking-stats d-flex align-center mt-1">
                      <div class="stat-item mr-4">
                        <span class="stat-label">CONFIRMADO:</span>
                        <span class="stat-value">{{ customer.confirmed | moneda }}</span>
                      </div>
                      <div class="stat-item">
                        <span class="stat-label">FACTURADO:</span>
                        <span class="stat-value grey--text">{{ customer.invoiced | moneda }}</span>
                      </div>
                    </div>
                    <!-- Subtle progress bar -->
                    <v-progress-linear
                      :value="(customer.invoiced / customer.confirmed) * 100"
                      color="blue"
                      background-color="blue lighten-4"
                      height="2"
                      rounded
                      class="mt-2"
                    ></v-progress-linear>
                  </div>
                  <v-icon small color="grey lighten-1">fas fa-chevron-right</v-icon>
                </div>
              </template>
              
              <!-- Empty State -->
              <div v-else class="ga-empty-state pa-12 text-center">
                <v-icon color="grey lighten-3" size="64">fas fa-folder-open</v-icon>
                <div class="mt-4 grey--text font-weight-medium">Sin datos en el periodo</div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </Can>
    
    <Can I="readAll" a="SalesNote">
      <v-col cols="12" md="6">
        <v-card class="bespoke-ranking-card h-100" flat>
          <div class="metric-accent success-accent"></div>
          <v-card-title class="pa-6 pb-2">
            <div class="d-flex flex-column">
              <span class="ranking-subtitle text-left">Fuerza de Ventas</span>
              <span class="ranking-title text-left">Top 5 Vendedores</span>
            </div>
            <v-spacer></v-spacer>
            <v-chip x-small color="success lighten-5" class="success--text font-weight-black">METAS</v-chip>
          </v-card-title>
          
          <v-card-text class="pa-0">
            <!-- Loading State -->
            <div v-if="loading" class="pa-6">
              <v-skeleton-loader v-for="i in 5" :key="i" type="list-item-two-line" class="mb-2"></v-skeleton-loader>
            </div>
            
            <!-- Real Data -->
            <div v-else class="bespoke-list">
              <template v-if="topSellersList.length > 0">
                <div 
                  v-for="(seller, index) in topSellersList" 
                  :key="index"
                  class="bespoke-list-item d-flex align-center pa-4"
                >
                  <div class="ranking-position mr-4">0{{ index + 1 }}</div>
                  <div class="ranking-info flex-grow-1">
                    <div class="ranking-name text-truncate text-left">{{ seller.name }}</div>
                    <div class="ranking-stats d-flex align-center mt-1">
                      <div class="stat-item mr-4">
                        <span class="stat-label">VENTA:</span>
                        <span class="stat-value">{{ seller.confirmed | moneda }}</span>
                      </div>
                      <div class="stat-item">
                        <span class="stat-label">RECAUDO:</span>
                        <span class="stat-value grey--text">{{ seller.invoiced | moneda }}</span>
                      </div>
                    </div>
                    <!-- Subtle progress bar -->
                    <v-progress-linear
                      :value="(seller.invoiced / seller.confirmed) * 100"
                      color="success"
                      background-color="success lighten-4"
                      height="2"
                      rounded
                      class="mt-2"
                    ></v-progress-linear>
                  </div>
                  <v-icon small color="grey lighten-1">fas fa-chevron-right</v-icon>
                </div>
              </template>
              
              <!-- Empty State -->
              <div v-else class="ga-empty-state pa-12 text-center">
                <v-icon color="grey lighten-3" size="64">fas fa-users-slash</v-icon>
                <div class="mt-4 grey--text font-weight-medium">Sin actividad registrada</div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </Can>
  </v-row>
</template>

<script>


const numeral = require('numeral');
const moment = require('moment')
export default {
  name:'DayGraphComplete',

  props:['customers','sellers','loading'],
  data:()=>({
    topCustomersList: [],
    topSellersList: [],
  }),
  methods:{
    processData(){
      // Verificar que los datos existen
      if (!this.customers || !this.customers[0] || !this.customers[1] || 
          !this.sellers || !this.sellers[0] || !this.sellers[1]) {
        console.log('DayGraphComplete - Datos no disponibles:', { customers: this.customers, sellers: this.sellers })
        return
      }
      
      // Procesar datos de clientes
      const customerDataSet = this.customers[0].map(customer => {
        const invoicedCustomer = this.customers[1].find(c => c.customer__id === customer.customer__id)
        return {
          id: customer.customer__id,
          name: customer.name,
          confirmed: customer.total,
          invoiced: invoicedCustomer ? invoicedCustomer.total : 0
        }
      })
      
      // Procesar datos de vendedores
      const sellerDataSet = this.sellers[0].map(seller => {
        const invoicedSeller = this.sellers[1].find(s => s.customer__seller__id === seller.customer__seller__id)
        return {
          id: seller.customer__seller__id,
          name: seller.full_name,
          confirmed: seller.total,
          invoiced: invoicedSeller ? invoicedSeller.total : 0
        }
      })
      
      // Ordenar por confirmado y tomar top 5
      this.topCustomersList = customerDataSet
        .sort((a, b) => b.confirmed - a.confirmed)
        .slice(0, 5)
      
      this.topSellersList = sellerDataSet
        .sort((a, b) => b.confirmed - a.confirmed)
        .slice(0, 5)
      
      console.log('DayGraphComplete - Datos procesados:', {
        customers: this.topCustomersList,
        sellers: this.topSellersList
      })
    },
  },
  mounted() {
    // Siempre procesar datos de prueba
    this.processData()
  },
  watch:{
    //Revisa cambios en options para solicitar data nuevamente
    customers:{
      deep: true,
      handler: 'processData'
    },
    sellers:{
      deep: true,
      handler: 'processData'
    },
  },
}
</script>

<style scoped>
/* Bespoke Ranking Cards */
.bespoke-ranking-card {
  position: relative;
  background: white !important;
  border: 1px solid rgba(0,0,0,0.08) !important;
  border-radius: 16px !important;
  transition: all 0.3s ease;
  overflow: hidden;
}

.metric-accent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
}

.blue-accent { background: #35BDC8; }
.success-accent { background: #4caf50; }

.ranking-subtitle {
  font-size: 0.7rem;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.ranking-title {
  font-size: 1.25rem;
  font-weight: 800;
  color: #1e293b;
  letter-spacing: -0.5px;
}

.bespoke-list-item {
  border-bottom: 1px solid rgba(0,0,0,0.03);
  transition: all 0.2s ease;
  cursor: pointer;
}

.bespoke-list-item:hover {
  background-color: #f8fafc;
}

.bespoke-list-item:last-child {
  border-bottom: none;
}

.ranking-position {
  font-size: 1.5rem;
  font-weight: 900;
  color: #e2e8f0;
  font-family: 'Outfit', sans-serif;
  width: 40px;
}

.ranking-name {
  font-size: 0.95rem;
  font-weight: 700;
  color: #334155;
}

.stat-label {
  font-size: 0.65rem;
  font-weight: 800;
  color: #94a3b8;
  margin-right: 4px;
}

.stat-value {
  font-size: 0.85rem;
  font-weight: 700;
  color: #475569;
}

.progress-container {
  width: 100%;
  height: 4px;
  background: #f1f5f9;
  border-radius: 2px;
  margin-top: 8px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  border-radius: 2px;
}
</style>

